import React, { Component } from 'react';
import close from "../images/icons/close1.png"
import { elasticLink, elasticHostURL } from "../config";
import { Link } from 'react-router-dom';
import searchico from "../images/lokal/search.png"
import search from "../images/icons/Search.png"
import GlobalSearchData from "../lokalIn/globalSearchData"
import GlobalSearchStoreData from "../lokalIn/globalSearchStoreData"
import $ from "jquery";
import { withRouter } from 'react-router-dom'; 
const AWS = require('aws-sdk');
const elasticsearch = require("elasticsearch");
AWS.config.region = 'us-west-1';
class Globalsearch extends Component {
    constructor() {
        super()
        this.state = {
            searchBoxShow: false,
            cart: true,
            groceryData: [],
            restaurantData: [],
            commonItemData: [],
            storeData: [],
            searchKey: '',
            isData: '0'
        }
        this.globalSearch = this.globalSearch.bind(this)
        this.searchClose = this.searchClose.bind(this)
    }
    async globalSearch(mode) {
        let siteId = localStorage.getItem('siteId');
        // var storeIdsBasedOnLocation = window.sessionStorage.getItem('storeIdsBasedOnLocation').toString().split(',')
        var keyWord = document.getElementById("txtSearchGlobal").value;
        const client = new elasticsearch.Client({
            host: elasticHostURL(),
            amazonES: {
                region: 'us-west-1',
                //credentials: new AWS.Credentials(this.state.s3AccessKey, this.state.s3SecretKey)
            }
        });
        const body = await client.search({
            index: elasticLink() + '-global-search',
            from: 0, size: 4,
            body: {
                query:
                {
                    bool: {
                        "must": {
                            "multi_match": {
                                "query": keyWord,
                                "type": "phrase_prefix",
                                "fields": ["search_item_name"]
                            }
                        },
                        filter:
                        {
                            bool:
                            {
                                must: [{
                                    terms: {
                                        site_id: [siteId]
                                    }
                                }, {
                                    term: {
                                        "section_name.keyword": mode
                                    }
                                }
                                    //     , {
                                    //     terms: {
                                    //         "store_id": storeIdsBasedOnLocation
                                    //     }
                                    // }
                                ]
                            }
                        }
                    }
                }
            }
        });
        if (mode === "Grocery") {
            this.setState({ groceryData: body.hits.hits, searchKey: keyWord, isData: '1' })
        }
        else if (mode === "Restaurant") {
            this.setState({ restaurantData: body.hits.hits, searchKey: keyWord, isData: '1' })
        }
        else if (mode === "CommonItem") {
            this.setState({ commonItemData: body.hits.hits, searchKey: keyWord, isData: '1' })
        }
        else {
            this.setState({ storeData: body.hits.hits, searchKey: keyWord, isData: '1' })
        }
    }
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent the default behavior of the Enter key (e.g., form submission)
          this.searchClose(); // Call your function to handle the "See more..." link
          this.navigateToSearchResult();
        }
      };
      navigateToSearchResult = () => {
        const { searchKey } = this.state;
        const { history } = this.props;
    
        history.push("/globalSearchResult", { searchKey: searchKey, mode: '' });
      };
    
    searchSolarDetails() {
        var keyWord = document.getElementById("txtSearchGlobal").value;
        if (keyWord !== '' && keyWord.length > 0) {
            document.getElementById("globalSearchDiv").style.display = "block";
            this.globalSearch("Grocery")
            this.globalSearch("Restaurant")
            this.globalSearch("CommonItem")
            this.globalSearch("Store")
        }
        else {
            this.setState({ groceryData: [], restaurantData: [], commonItemData: [], storeData: [], isData: '0' })
        }
    }
    searchClose() {
        this.setState({ groceryData: [], restaurantData: [], commonItemData: [], storeData: [], isData: '0' })
    }
    locationClick() {
        $(".locationPopUp").show();
    }
    render() {
        let locationId = localStorage.getItem('locationId')
        return (
            <div className="headerIcons">
                <div className="headerSearch">
                    {(locationId !== null && locationId !== 'null' && locationId !== '') ?
                        <div class="searchField">
                            <input type="text" autoComplete="off" placeholder="Search for products and stores" id="txtSearchGlobal" name="txtSearchGlobal"  onKeyDown={this.handleKeyDown} onKeyUp={(e) => this.searchSolarDetails()} />
                            <span className="searchBtn" ><img src={searchico} alt="" /></span>
                        </div>
                        :
                        <div class="searchField" onClick={this.locationClick}>
                            <input type="text" autoComplete="off" placeholder="Search for products and stores" id="txtSearchGlobal" name="txtSearchGlobal"  onKeyDown={this.handleKeyDown} onKeyUp={(e) => this.searchSolarDetails()} />
                            <span className="searchBtn" disabled><img src={searchico} alt="" /></span>
                        </div>
                    }
                    <div id="globalSearchDiv">
                        {this.state.groceryData.length > 0 || this.state.restaurantData.length > 0 || this.state.commonItemData.length > 0 || this.state.storeData.length > 0 ?
                            <div className="globalSearch">
                                <div className="globalSearchOverlay"></div>
                                <div className="globalSearchPop">
                                    <span className="cartClose cartRemoveItem" onClick={(e) => this.searchClose()}><img src={close} alt="" /></span>
                                    <div className="globalSearchContent">
                                        {this.state.groceryData.length > 0 ?
                                            <div>
                                                <div className="globalSearchTitle">
                                                    {/* <span>Grocery</span> */}
                                                    <span>Products</span>
                                                    </div>
                                                <div className="globalSearchRow">
                                                    {this.state.groceryData.slice(0, 4).map((dataObject, index) => (
                                                        <GlobalSearchData dataObject={dataObject} index={index}></GlobalSearchData>
                                                    ))}
                                                    {/* {this.state.groceryData.length > 4 ?
                                                        <div className="addMoreItemList">
                                                            <Link className="text-decoration" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Grocery' } }}  >
                                                                <div className="addMoreItem">
                                                                    <div className="addMoreItemContent">
                                                                        <span className="addMorePlus">+</span>
                                                                        <span>See more...</span>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div>  */}
                                                        
                                                        {/* <Link className="text-decoration seemore-link" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Grocery' } }} >
                                                            See more...
                                                        </Link> */}
                                                        {/* : ''} */}

                                                </div>
                                                
                                                        <Link className="text-decoration seemore-link" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Grocery' } }} >
                                                             See more products...
                                                        </Link>
                                            </div>
                                            : ''}
                                        {this.state.restaurantData.length > 0 ?
                                            <div>
                                                <div className="globalSearchTitle"><span>Restaurant</span></div>
                                                <div className="globalSearchRow">
                                                    {this.state.restaurantData.slice(0, 4).map((dataObject, index) => (
                                                        <GlobalSearchData dataObject={dataObject} index={index}></GlobalSearchData>
                                                    ))}
                                                    {/* {this.state.restaurantData.length > 4 ?
                                                        <div className="addMoreItemList">
                                                             <Link className="text-decoration" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Restaurant' } }}  >
                                                                <div className="addMoreItem">
                                                                    <div className="addMoreItemContent">
                                                                        <span className="addMorePlus">+</span>
                                                                        <span>See more...</span>
                                                                    </div>
                                                                </div>
                                                            </Link> 
                                                        </div> */}
                                                        <Link className="text-decoration seemore-link" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Restaurant' } }}  >
                                                             See more...
                                                        </Link>
                                                        {/* : ''} */}
                                                </div>
                                            </div>
                                            : ''}
                                        {this.state.commonItemData.length > 0 ?
                                            <div>
                                                <div className="globalSearchTitle"><span>Common Items</span></div>
                                                <div className="globalSearchRow">
                                                    {this.state.commonItemData.slice(0, 4).map((dataObject, index) => (
                                                        <GlobalSearchData dataObject={dataObject} index={index}></GlobalSearchData>
                                                    ))}
                                                    {/* {this.state.commonItemData.length > 4 ?
                                                        <div className="addMoreItemList">
                                                            <Link className="text-decoration" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'CommonItem' } }}  >
                                                                <div className="addMoreItem">
                                                                    <div className="addMoreItemContent">
                                                                        <span className="addMorePlus">+</span>
                                                                        <span>See more...</span>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div> */}
                                                        <Link className="text-decoration seemore-link" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'CommonItem' } }}  >
                                                             See more...
                                                        </Link>
                                                         {/* : ''} */}
                                                </div>
                                            </div>
                                            : ''}
                                        {this.state.storeData.length > 0 ?
                                            <div>
                                                <div className="globalSearchTitle"><span>Stores</span></div>
                                                <div className="globalSearchRow">
                                                    {this.state.storeData.slice(0, 4).map((dataObject, index) => (
                                                        <GlobalSearchStoreData dataObject={dataObject} searchKey={this.state.searchKey}  onSeeMoreClick={this.searchClose}></GlobalSearchStoreData>
                                                    ))}
                                                    {/* {this.state.storeData.length > 4 ?
                                                        <div className="addMoreItemList">
                                                             <Link className="text-decoration" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Store' } }}  >
                                                                <div className="addMoreItem">
                                                                    <div className="addMoreItemContent">
                                                                        <span className="addMorePlus">+</span>
                                                                        <span>See more...</span>
                                                                    </div>
                                                                </div>
                                                            </Link> 
                                                        </div> */}
                                                        {/* <Link className="text-decoration seemore-link" onClick={(e) => this.searchClose()} to={{ pathname: "/globalSearchResult", state: { searchKey: this.state.searchKey, mode: 'Store' } }}  >
                                                             See more...
                                                        </Link> */}
                                                        {/* : ''} */}
                                                </div>
                                            </div>
                                            : ''}
                                    </div>
                                </div>
                            </div>
                            :
                            this.state.isData === "1" ?
                                <div class="globalSearch">
                                    <div class="globalSearchOverlay"></div>
                                    <div className="globalSearchPop text-center">
                                        <span className="cartClose cartRemoveItem" onClick={(e) => this.searchClose()}><img src={close} alt="" /></span>
                                        <div className="globalSearch-nodata">
                                            Sorry...! No data for "<span style={{ color: "#24b0a6" }}>{this.state.searchKey}</span>" in {localStorage.getItem('locationText')} location.
                                        </div>
                                    </div>
                                </div>
                                : ""
                        }
                    </div>
                    <div className="mobileSearch" ><img src={search} alt="" /></div>
                </div>
            </div>
        )
    }
}
export default withRouter(Globalsearch);